// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"225":"805f80f2","291":"5ff9ba33"}[chunkId] + ".js";
};